export const brand = {
  name: 'Pulse Padel Hub',
  /** Transparent PNG built for dark backgrounds — white wordmark, blue panel, magenta pulse. */
  logoSrc: 'https://cdn.magicpatterns.com/uploads/i4HdQr1zUvVRZpSKx14QXf/pulse_logo_transparent.png',
  logoAlt: 'Pulse Padel Hub NoMi logo',
}

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Courts', href: '#courts' },
  { label: 'Programs', href: '#programs' },
  { label: 'Community', href: '#community' },
  { label: 'Contact', href: '#contact' },
]

export const stats = [
  { value: '6', label: 'Pro Courts' },
  { value: 'Free', label: 'On-Site Parking' },
  { value: 'Late', label: 'Open Until Late' },
  { value: 'All', label: 'Skill Levels' },
]

export const features = [
  {
    icon: 'court',
    title: 'Six Pro Courts',
    description:
      'Panoramic, pro-grade glass courts under stadium LED lighting — built for night play.',
  },
  {
    icon: 'parking',
    title: 'Free On-Site Parking',
    description:
      'Pull up, park steps from the door, and be warming up in under two minutes. No meters, no hassle.',
  },
  {
    icon: 'community',
    title: 'Vibrant Community',
    description:
      'Open plays, socials and leagues that mix you in with players at your level — every single week.',
  },
  {
    icon: 'levels',
    title: 'All Ages & Levels',
    description:
      'From first-time beginners to 5.0+ competitors and kids clinics on the weekends. Everyone plays.',
  },
] as const

export const programs = [
  {
    day: 'Mondays',
    name: 'Beginner Open',
    level: '0.5 – 2.0',
    time: '7:30 PM',
    accent: 'blue',
  },
  {
    day: 'Tuesdays',
    name: 'Intermediate Open',
    level: '2.0 – 3.5',
    time: '8:30 PM',
    accent: 'purple',
  },
  {
    day: 'Thursdays',
    name: 'Advanced Open',
    level: '3.5 – 5.0+',
    time: '7:30 PM',
    accent: 'magenta',
  },
  {
    day: 'Saturdays',
    name: 'Kids Clinics',
    level: 'Ages 6 – 14',
    time: '11:00 AM – 12:30 PM',
    accent: 'blue',
  },
  {
    day: 'Sundays',
    name: 'Open Play',
    level: 'All levels',
    time: 'All day',
    accent: 'purple',
  },
] as const

export const gallery = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/fa0d3c33-3b21-4e49-8a0f-0e6680184aa7.jpg',
    alt: 'Two players mid-rally on a neon-lit padel court',
    span: 'row',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/d1f33380-5b81-41eb-9af0-4ec7425513b4.jpg',
    alt: 'Friends laughing together with padel rackets beside the court',
    span: 'wide',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/b79772d7-650b-44fc-84aa-2619594b6252.jpg',
    alt: 'Coach leading a kids padel clinic',
    span: 'default',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/233fcc77-c3a5-4716-88e0-73891f922825.jpg',
    alt: 'Padel rackets and balls on the court floor under neon light',
    span: 'default',
  },
] as const

export const contact = {
  address: '1355 NW 135th St, North Miami, FL 33167',
  phone: '(754) 209-9564',
  phoneHref: 'tel:+17542099564',
  instagram: '@pulsepadelhub',
  instagramHref: 'https://instagram.com/pulsepadelhub',
  booking: 'Book on Playtomic',
  /** Single source of truth for every booking CTA on the site. */
  bookingHref: 'https://playtomic.com/clubs/pulse-padel-hub',
}

export const showcase = {
  /** Swap this for a transparent PNG/WebP cutout and flip `racketNeedsBlend` to false. */
  racketImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/d28edd3c-fc12-4385-b153-de42abe47837.jpg',
  racketAlt: 'Padel racket and ball lit by blue and magenta neon',
  racketNeedsBlend: true,
  words: ['Spin', 'Power', 'Play'],
  eyebrow: 'The Pulse Object',
  title: 'Engineered for night play',
  caption:
    'Neon-lit glass, floodlit courts and a room that hums until close. This is what a session at Pulse feels like.',
}

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/46ed2f2b-dc0d-40a6-91eb-40efcfde3760.jpg'
